import { createModule as createM, } from './module'
import i from './init'
import * as statusConstants from './constants'


export const createModule = createM
export const init  = i
export const constants = statusConstants
export const STATUS = statusConstants



// WEBPACK FOOTER //
// ./src/index.js